import * as dateFnsPT from 'date-fns/locale/pt';

export const INFINITE_CALENDAR_DEFAULTS = {
  locale: dateFnsPT,
  blank: 'Selecione um período...',
  headerFormat: 'ddd, D de MMM',
  todayLabel: {
    long: 'Hoje',
    short: 'Hj',
  },
  weekdays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  weekStartsOn: 0,
};



// WEBPACK FOOTER //
// ./src/constants.js